import { createSelector } from "reselect"
import { chain, includes, keyBy, keys } from "lodash"
import { computeAvailableSelectViewFactors, getFactorCategory, getFactorLabel } from "helpers/factors"
import { aggregateFactors } from "helpers/factorClassification/index"
import { getDisabled } from "modules/factor-trends/selectors"
import { getFactorsMetadata, getSelectedViews, getFavoriteFactors } from "modules/factor-trends/selectors/factors"
import { getModelFactorsClassification } from "selectors/modelMetadata"
import { getNonZerosKeys } from "./data"
import { getCurrentPerformance } from "./performance"

const getNonZeroComputedFactors = createSelector(
  [getFactorsMetadata, getCurrentPerformance, getDisabled, getFavoriteFactors, getNonZerosKeys],
  (factorsMetadata, lastDatum, disabled, favoriteFactors, nonZerosKeys) => {
    const filteringKeys = keys(nonZerosKeys)
    return chain(lastDatum)
      .get("factors")
      .map((performance, id) => includes(filteringKeys, id) && ({
        id,
        lastValue: performance,
        label: getFactorLabel(factorsMetadata, id),
        category: getFactorCategory(factorsMetadata, id),
        favorite: favoriteFactors[id],
        field: `factors.${id}`,
        disabled: !!disabled[id],
        type: "factors",
      }))
      .compact()
      .orderBy(["favorite", (item) => Math.abs(item.lastValue)], ["asc", "desc"])
      .value()
  },
)

export const getAlwaysAggregatedFactors = createSelector(
  [getNonZeroComputedFactors, getModelFactorsClassification],
  (computedFactors, factorsClassification) => {
    const factors = aggregateFactors(factorsClassification, computedFactors)
    return keyBy(factors, "id")
  },
)

// All getAlwaysAggregateFactors factors are nonZero so we can use them as 3rd parameter (nonZerosKeys)
export const getAvailableSelectViewFactors = createSelector(
  [getAlwaysAggregatedFactors, getModelFactorsClassification, getSelectedViews, getAlwaysAggregatedFactors],
  computeAvailableSelectViewFactors,
)
